import { render, staticRenderFns } from "./ProductDetailEdit.vue?vue&type=template&id=5ad9abe7&scoped=true&"
import script from "./ProductDetailEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailEdit.vue?vue&type=style&index=0&id=5ad9abe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9abe7",
  null
  
)

export default component.exports